import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import Button from '../../components/Button';
import FgiModal from '../../components/FgiModal';
import Markdown from '../../components/Markdown';
import { useGlobalState } from '../../hooks';

export const ModeratorFindenModal = ({
  show,
  onHide,
  onCategoryClick,
  moderatorFindenItems,
}) => {
  const [{ locale }] = useGlobalState();
  const [t] = useTranslation();

  return (
    <FgiModal
      color="green"
      title={t('Header.findModerator')}
      description={t('Wobei dürfen wir Sie unterstützen?')}
      onHide={onHide}
      show={show}
    >
      <div className="modal-list-container">
        {moderatorFindenItems.map((item) => (
          <div key={item.id} className="modal-list-container-item">
            <div className="modal-list-container-item-title title-article">
              {item.title?.[locale]}
            </div>
            <div className="modal-list-container-item-description description">
              <Markdown>{item.description?.[locale]}</Markdown>
            </div>
            <Button
              onClick={onCategoryClick(item)}
              size="medium"
              variant="green"
            >
              {t('Wählen')}
            </Button>
          </div>
        ))}
      </div>
    </FgiModal>
  );
};

ModeratorFindenModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onCategoryClick: PropTypes.func.isRequired,
  moderatorFindenItems: PropTypes.array.isRequired,
};

export default ModeratorFindenModal;
